var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section promo-area ptb_100",attrs:{"id":"seccion-formatos"}},[_c('div',{staticClass:"container scrollNew"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-3"},[_c('FormatosFree')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }